export default (url: string): boolean =>
    url.startsWith('/') || url.startsWith('#')
